import React from 'react'

import Table from 'components/Table'

import { CriticalAndMajorAlert } from 'types/AdminNotificationsPolicy'
import { color } from 'styles/colors'

import styled from 'styled-components'
import { screenSize } from 'styles/shared'

type Props = {
    criticalAndMajorAlert: Required<CriticalAndMajorAlert>
    enabled: boolean
  }

const AlertNotificationCell = ({ criticalAndMajorAlert, enabled } : Props) => {
  return (
    <>
      <S.Cell {... { enabled }}>{criticalAndMajorAlert.code}</S.Cell>
      <S.Cell {... { enabled }}>{criticalAndMajorAlert.severity}</S.Cell>
      <S.Cell {... { enabled }}>{criticalAndMajorAlert.description}</S.Cell>
      <S.Cell {... { enabled }}>{criticalAndMajorAlert.problems}</S.Cell>
    </>
  )
}

export default AlertNotificationCell

const S = {
  Cell: styled(Table.Cell).withConfig({
    shouldForwardProp: (prop) => !['enabled'].includes(prop)
  })<{ enabled: boolean }>`
    display: flex;
    padding-left: 10px;
    text-overflow: ellipsis;
    line-height: 18px;
    ${({ enabled }) => !enabled && `color: ${color('disabledAlertNotification')};`}

    @media ${screenSize.small} {
      line-height: 30px;
    }
  `
}
